module.exports = __webpack_public_path__ + "img/jgl1.47507ba7.jpg";